import React from "react"

import { Image } from "./styles"

const ImageAdUnit = ({ className, element }) => {
  const { image, url } = element
  const [{ secure_url: imageUrl }] = image

  return (
    <a className={className} href={url}>
      <Image src={imageUrl} />
    </a>
  )
}

export default ImageAdUnit
